import { EgretLoadable } from 'egret';
import { authRoles } from '../../auth/authRoles';

const ApiDoc = EgretLoadable({
  loader: () => import('./ApiDoc')
});

const CardPresentQuickStart = EgretLoadable({
  loader: () => import('./CardPresentApiQuickStart')
});

const TestCards = EgretLoadable({
  loader: () => import('./TestCards')
});

const QuickStart = EgretLoadable({
  loader: () => import('./QuickStart')
});

const HostedPaymentFormApi = EgretLoadable({
  loader: () => import('./HostedPaymentFormApi')
});

const docRoutes = [
  {
    path: '/apidocs',
    component: ApiDoc,
    auth: authRoles.developer
  },
  {
    path: '/test-cards',
    component: TestCards,
    auth: authRoles.developer
  },
  {
    path: '/quickstart',
    component: QuickStart,
    auth: authRoles.developer
  },
  {
    path: '/hosted-payment-form-api',
    component: HostedPaymentFormApi,
    auth: authRoles.developer
  },
  {
    path: '/card-present-api',
    component: CardPresentQuickStart,
    auth: authRoles.developer
  }
];

export default docRoutes;
